// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/*globals data */

import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
//import posthog from 'posthog-js'
import * as TinyCookie from 'tiny-cookie'
import '@/helpers/toastification';
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
// import VueCookies from 'vue-cookies';
// Vue.use(VueCookies);
//VueCookies.config('1d');
import VueCookie from 'vue-cookie';
Vue.use(VueCookie);
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router';
import store from './store';
Vue.prototype.jQuery = $;

import Highcharts from 'highcharts';
import Maps from 'highcharts/modules/map';
import HighchartsVue from 'highcharts-vue';

Maps(Highcharts);
Vue.use(HighchartsVue);

import '@toast-ui/editor/dist/toastui-editor.css';

import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
Vue.use(VueMoment, {
  moment
});
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors'
});
import money from './views/components/vDecimalInput/index.js';
// register directive v-money and component <money>
Vue.use(money, {
  decimal: '.',
  thousands: ',',
  prefix: '',
  suffix: '',
  precision: 2,
  masked: true /* doesn't work with directive */
});

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
import 'sweetalert2/dist/sweetalert2.min.css';
import Gravatar from 'vue-gravatar';
Vue.component('v-gravatar', Gravatar);
import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

import bsSelect from './views/components/BsSelect.vue';
import bsSelectMultiple from './views/components/BsSelectMultiple.vue';

Vue.component('b-v-select', bsSelect);
Vue.component('b-v-select-multi', bsSelectMultiple);

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.component('Flatpickr', flatPickr);

Vue.config.productionTip = false;

const $http = require('axios');
window.$http = Vue.prototype.$http = $http;
window.Sentry = Vue.prototype.Sentry = Sentry;
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

// Global registration
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

Vue.use(BootstrapVue);
// import 'froala-editor/js/third_party/spell_checker.min';
// import 'froala-editor/js/third_party/image_tui.min';
// // Import Froala Editor css files.
// import 'froala-editor/css/froala_editor.pkgd.min.css';

// // Import and use Vue Froala lib.
// import VueFroala from 'vue-froala-wysiwyg'
// Vue.use(VueFroala)

Vue.config.productionTip = false

var filter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('span');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};
Vue.filter('truncate', filter);

import NotificationsHub from './helpers/notificationsHub';
Vue.use(NotificationsHub);

import VueCountdown from '@chenfengyuan/vue-countdown';
Vue.component(VueCountdown.name, VueCountdown);

let dsnKey = 'https://40e47ba2e8d6ed828de4873bdd713681@o4504445801988096.ingest.us.sentry.io/4507567044952064';
let envSentry = '';
if (window.location.hostname.includes('localhost')) {
  envSentry = 'localhost';
} else {
  envSentry = 'production';
}
$http.interceptors.response.use(
  (response) => response,
  (error) => {
    if(error && error.response && error.response.status != 404 && !(error.response.config.url.includes('refresh-token'))) {
      Sentry.withScope(scope => {
        scope.setExtra('Method', error.response.config.method)
        scope.setExtra('Response', error.response.data)
        // try {
        //    scope.setExtra('ResponseString', JSON.stringify(error.response.data))
        // } catch {}
        scope.setExtra('URL', error.response.config.url)
        error.name = 'API Error';
        error.message = 'API Call Failed for ' + error.response.config.url;
        Sentry.captureException(error);
      });
    }
    return Promise.reject(error);
  },
);
Sentry.init({
  environment: envSentry,
  Vue,
  dsn: dsnKey,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', 'stagingsupport.ux.app', 'support.ux.app', 'staging.UxAppSupport.com', 'UxAppSupport.com', /^\//],
    })
  ],
  normalizeDepth: 6,
  logErrors: true,
  trackComponents: true,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});


/* eslint-disable no-new */
window.mainVue = new Vue({
  el: '#app',
  filters: {
    fromNow(date) {
      return moment(date).fromNow();
    }
  },
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});

window.$cookie = TinyCookie;
window.mainStore = store;

import './registerServiceWorker';
